import { cn } from '@/lib/utils';
import type { MethodBrand } from './methodBrand';

const BRAND_CLASSES: Record<MethodBrand, string> = {
  orange: 'bg-gradient-to-br from-[#FF6F00] to-[#FF8C00] text-white border-transparent',
  mtn: 'bg-[#FFCC00] text-charcoal-950 border-[#D4A800]',
  wave: 'bg-[#1DC8E0] text-white border-transparent',
  stripe: 'bg-gradient-to-br from-[#635BFF] to-[#7A73FF] text-white border-transparent',
  cash: 'bg-charcoal-100 text-charcoal-700 border-charcoal-200',
  other: 'bg-charcoal-200 text-charcoal-700 border-charcoal-300',
};

const BRAND_LABEL: Record<MethodBrand, string> = {
  orange: 'OM',
  mtn: 'MTN',
  wave: 'WV',
  stripe: 'ST',
  cash: 'CA',
  other: '••',
};

interface MethodLogoProps {
  brand: MethodBrand;
  size?: 'sm' | 'md';
  className?: string;
}

export function MethodLogo({ brand, size = 'md', className }: MethodLogoProps) {
  const sizeClass = size === 'sm' ? 'w-5 h-5 text-[7px]' : 'w-7 h-7 text-[9px]';
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-sm border font-heading font-extrabold uppercase tracking-tight',
        sizeClass,
        BRAND_CLASSES[brand],
        className,
      )}
    >
      {BRAND_LABEL[brand]}
    </span>
  );
}
